import React from 'react';

export default function UploadedImages({ questions, answers }) {

  const attachments = questions.filter((item) => {
    return item.type === 'attachment';
  });

  const getAttachments = () => {
    for (const attachment of attachments) {
      const response = answers.find((answer) => {
        return answer.linkId === attachment.linkId;
      });

      const images = response.answer.map((image) => {
        return image.valueAttachment
      });

      return images.filter(image => image !== null)
    }
  }

  if (attachments.length !== 0 && getAttachments().length > 0) {
    return <div className="card axs-shadow mt-3">
      <div className="card-header">
        <h6>Uploaded Images</h6>
      </div>
      <div className="card-body">
        {getAttachments().map((image, i) => {
          if (image) {
            return <a href={image} target="_blank" rel="noopener noreferrer">
              <img
                key={i}
                src={image}
                width="125px" className="img-thumbnail mr-1" alt="Upload" />
            </a>
          }
        })}
      </div>
    </div>
  } else {
    return null
  }

}